import https from "../utils/http";
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/testIp/request/";

/*
 * 登录
 * */
// post请求
export function login(params) {
    return https.post(`register/login`, params);
}

// get请求
export function loginGetCode(params) {
    return https.get(`/QrcodeLogin/getQrcode`, params);
}

// get请求
export function loginCheckCode(params) {
    return https.get(`/QrcodeLogin/checkQrCodeLogin`, params);
}

/*
 * 注册用户
 * */
export function register(params) {
    return https.post(`register/index`, params);
}
/*
 * 注册页面用户协议
 * */
export function userAgreement(params) {
    return https.get(`/register/xy`, params);
}
/*
 * 忘记密码
 * */
export function forgetpwd(params) {
    return https.post(`/register/forgetpwd`, params);
}
/*
 * 退出登录-缺接口
 * */
export function logout(params) {
    return https.post(`register/login`, params);
}

// get请求
export function getListAPI(params) {
    return https.get(`${resquest}/getList.json`, params);
}
// post请求
export function postFormAPI(params) {
    return https.post(`${resquest}/postForm.json`, params);
}
// put 请求
export function putSomeAPI(params) {
    return https.put(`${resquest}/putSome.json`, params);
}
// delete 请求
export function deleteListAPI(params) {
    return https.delete(`${resquest}/deleteList.json`, params);
}




// WEBPACK FOOTER //
// ./src/api/api.js